/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
if (!window.Utility) { window.Utility = {}; }

Utility.Fireworks = class Fireworks {
  static launch() {
    // Based on:
    // https://codepen.io/boomershin/pen/ByLVPO
    // Code by Matheus Lin
    // While developing a version of "Chain Reaction", I ended up on
    // those "fireworks-like" things. I leave it to you here.
    // Chain Reaction coming up next!
    // Configs
    let screenWidth = window.innerWidth;
    let screenHeight = window.innerHeight;
    let minVx = -10;
    let deltaVx = 20;
    let minVy = 25;
    let deltaVy = 15;
    const minParticleV = 5;
    const deltaParticleV = 5;
    const gravity = 1;
    const explosionRadius = 200;
    const bombRadius = 10;
    const explodingDuration = 100;
    const explosionDividerFactor = 10;
    // I couldn't find a better name. Got any?
    const nBombs = 2;
    // initial
    const percentChanceNewBomb = 10;
    // Color utils forked from http://andreasstorm.com/
    // (or someone who forked from there)

    const Color = function(min) {
      min = min || 0;
      this.r = colorValue(min);
      this.g = colorValue(min);
      this.b = colorValue(min);
      this.style = createColorStyle(this.r, this.g, this.b);
    };

    var colorValue = min => Math.floor((Math.random() * 255) + min);

    var createColorStyle = (r, g, b) => 'rgba(' + r + ',' + g + ',' + b + ', 0.8)';

    // A Bomb. Or firework.

    const Bomb = function() {
      const self = this;
      self.radius = bombRadius;
      self.previousRadius = bombRadius;
      self.explodingDuration = explodingDuration;
      self.hasExploded = false;
      self.alive = true;
      self.color = new Color;
      self.px = (window.innerWidth / 4) + ((Math.random() * window.innerWidth) / 2);
      self.py = window.innerHeight;
      self.vx = minVx + (Math.random() * deltaVx);
      self.vy = (minVy + (Math.random() * deltaVy)) * -1;
      // because y grows downwards
      self.duration = 1000;
      self.update = function(particlesVector) {
        if (self.hasExploded) {
          const deltaRadius = explosionRadius - (self.radius);
          self.previousRadius = self.radius;
          self.radius += deltaRadius / explosionDividerFactor;
          self.explodingDuration--;
          if (self.explodingDuration === 0) {
            self.alive = false;
          }
        } else {
          self.vx += 0;
          self.vy += gravity;
          if (self.vy >= 0) {
            // invertion point
            self.explode(particlesVector);
          }
          self.px += self.vx;
          self.py += self.vy;
        }
      };

      self.draw = function(ctx) {
        ctx.beginPath();
        ctx.arc(self.px, self.py, self.previousRadius, 0, Math.PI * 2, false);
        if (self.hasExploded) {
        } else {
          ctx.fillStyle = self.color.style;
          ctx.lineWidth = 1;
          ctx.fill();
        }
      };

      self.explode = function(particlesVector) {
        self.hasExploded = true;
        const e = 3 + Math.floor(Math.random() * 3);
        let j = 0;
        while (j < e) {
          var n = 10 + Math.floor(Math.random() * 21);
          // 10 - 30
          var speed = minParticleV + (Math.random() * deltaParticleV);
          var deltaAngle = (2 * Math.PI) / n;
          var initialAngle = Math.random() * deltaAngle;
          var i = 0;
          while (i < n) {
            particlesVector.push(new Particle(self, (i * deltaAngle) + initialAngle, speed));
            i++;
          }
          j++;
        }
      };

    };

    var Particle = function(parent, angle, speed) {
      const self = this;
      self.px = parent.px;
      self.py = parent.py;
      self.vx = Math.cos(angle) * speed;
      self.vy = Math.sin(angle) * speed;
      self.color = parent.color;
      self.duration = 40 + Math.floor(Math.random() * 20);
      self.alive = true;

      self.update = function() {
        self.vx += 0;
        self.vy += gravity / 10;
        self.px += self.vx;
        self.py += self.vy;
        self.radius = 3;
        self.duration--;
        if (self.duration <= 0) {
          self.alive = false;
        }
      };

      self.draw = function(ctx) {
        ctx.beginPath();
        ctx.arc(self.px, self.py, self.radius, 0, Math.PI * 2, false);
        ctx.fillStyle = self.color.style;
        ctx.lineWidth = 1;
        ctx.fill();
      };

    };

    const Controller = function() {
      const self = this;

      const setSpeedParams = function() {
        let heightReached = 0;
        let vy = 0;
        while ((heightReached < screenHeight) && (vy >= 0)) {
          vy += gravity;
          heightReached += vy;
        }
        minVy = vy / 2;
        deltaVy = vy - minVy;
        const vx = ((1 / 4) * screenWidth) / (vy / 2);
        minVx = -vx;
        deltaVx = 2 * vx;
      };

      self.canvas = document.getElementById('fireworks');
      self.canvas.width = screenWidth;
      self.canvas.height = screenHeight;
      self.ctx = self.canvas.getContext('2d');

      self.resize = function() {
        screenWidth = window.innerWidth;
        screenHeight = window.innerHeight;
        self.canvas.width = screenWidth;
        self.canvas.height = screenHeight;
        setSpeedParams();
      };

      self.resize();
      window.onresize = self.resize;

      self.init = function() {
        self.ctx.clearRect(0, 0, self.canvas.width, self.canvas.height);
        self.readyBombs = [];
        self.explodedBombs = [];
        self.particles = [];
        self.duration = Math.floor((Math.random() * 2500) + 2000);
        // console.log self.duration
        self.startedAt = new Date().getTime();
        let i = 0;
        while (i < nBombs) {
          self.readyBombs.push(new Bomb);
          i++;
        }
        $("#fireworks").removeClass('hidden').show();
        return;
      };

      self.update = function() {
        let bomb;
        const aliveBombs = [];
        while (self.explodedBombs.length > 0) {
          bomb = self.explodedBombs.shift();
          bomb.update();
          if (bomb.alive) {
            aliveBombs.push(bomb);
          }
        }
        self.explodedBombs = aliveBombs;
        const notExplodedBombs = [];
        while (self.readyBombs.length > 0) {
          bomb = self.readyBombs.shift();
          bomb.update(self.particles);
          if (bomb.hasExploded) {
            self.explodedBombs.push(bomb);
          } else {
            notExplodedBombs.push(bomb);
          }
        }
        self.readyBombs = notExplodedBombs;
        const aliveParticles = [];
        while (self.particles.length > 0) {
          var particle = self.particles.shift();
          particle.update();
          if (particle.alive) {
            aliveParticles.push(particle);
          }
        }
        self.particles = aliveParticles;
      };

      self.draw = function() {
        self.ctx.beginPath();
        self.ctx.fillStyle = 'rgba(0, 0, 0, 0)';
        // Ghostly effect
        self.ctx.fillRect(0, 0, self.canvas.width, self.canvas.height);
        let i = 0;
        while (i < self.readyBombs.length) {
          self.readyBombs[i].draw(self.ctx);
          i++;
        }
        i = 0;
        while (i < self.explodedBombs.length) {
          self.explodedBombs[i].draw(self.ctx);
          i++;
        }
        i = 0;
        while (i < self.particles.length) {
          self.particles[i].draw(self.ctx);
          i++;
        }
      };

      self.animation = function() {
        const timer = new Date().getTime() - self.startedAt;
        if (timer < self.duration) {
          self.update();
          self.draw();
          if ((Math.random() * 100) < percentChanceNewBomb) {
            self.readyBombs.push(new Bomb);
          }
          requestAnimationFrame(self.animation);
        } else {
          $("#fireworks").fadeOut('slow');
        }
      };
    };

    const controller = new Controller;
    controller.init();
    return requestAnimationFrame(controller.animation);
  }
};
